/**
 * Uses Swiper package to create a carousel for announcement bar
 * More info: https://swiperjs.com/
 */
if (!customElements.get('custom-accordion')) {
  class customAccordion extends HTMLElement {
    constructor() {
      super();

      this.accordionItems = this.querySelectorAll('[data-accordion-item]');

      this.accordionItems.forEach(accordionItem => {
        this.calcHeight(accordionItem);
      });
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.accordionItems.forEach(accordionItem => {
        accordionItem.querySelector('[data-accordion-item-trigger]').addEventListener('click', () => {
          this.toggleAccordionItem(accordionItem)
        });
      });
    }

    toggleAccordionItem(accordionItem) {
      accordionItem.classList.toggle('is-open');

      this.calcHeight(accordionItem);
    }

    calcHeight(accordionItem) {
      const accordionItemBody = accordionItem.querySelector('[data-accordion-item-body]');
      const accordionItemContent = accordionItem.querySelector('[data-accordion-item-content]');
      const styles = { maxHeight: 0, visibility: 'hidden' }

      if (!accordionItem.classList.contains('is-open')) {
        Object.assign(accordionItemBody.style, styles)

        return
      }

      styles.maxHeight = accordionItemContent.getBoundingClientRect().height + 'px';
      styles.visibility = 'visible';

      Object.assign(accordionItemBody.style, styles)
    }
  }

  customElements.define('custom-accordion', customAccordion);
}
